export default __webpack_public_path__ + "static/media/welcome.26e58b2b.jpg";